// extracted by mini-css-extract-plugin
export default {"App":"peacegame_App_App","team":"peacegame_App_team"};